import { fetch } from '../utils/fetch'
import { isSuperAdmin } from '../utils/auth'
import { ENDPOINT_HIERARCHY, ENDPOINT_ALBUM_PATH_COUNTS } from '../constants'

const HIERARCHY_REQUEST = 'blayzr/hierarchy/REQUEST'
const HIERARCHY_SUCCESS = 'blayzr/hierarchy/SUCCESS'
const HIERARCHY_FAILURE = 'blayzr/hierarchy/FAIL'

const PATH_COUNTS_REQUEST = 'blayzr/hierarchy/PATH_COUNTS_REQUEST'
const PATH_COUNTS_SUCCESS = 'blayzr/hierarchy/PATH_COUNTS_SUCCESS'
const PATH_COUNTS_FAILURE = 'blayzr/hierarchy/PATH_COUNTS_FAIL'

const TOGGLE_EXPANDED = 'blayzr/hierarchy/TOGGLE_EXPANDED'
const COLLAPSE_ALL = 'blayzr/hierarchy/COLLAPSE_ALL'

const initialState = {
  data: null,
  fetching: false,
  error: null,
  expanded: [],
  paths: {
    data: null,
    fetching: false,
    error: null
  }
}

export default function reducer (state = initialState, action = {}) {
  const { type, payload, meta } = action
  switch (type) {
    case HIERARCHY_REQUEST:
      return {
        ...state,
        fetching: true,
        error: null
      }
    case HIERARCHY_SUCCESS:
      return {
        ...state,
        fetching: false,
        data: getHierarchy(payload, meta.libraries),
        full: meta.superAdmin ? payload[''] : undefined
      }
    case HIERARCHY_FAILURE:
      return {
        ...state,
        fetching: false,
        error: meta.error
      }
    case TOGGLE_EXPANDED:
      const expanded =
        state.expanded.indexOf(payload) === -1
        ? state.expanded.concat(payload)
        : state.expanded.filter(path => path !== payload)
      return {
        ...state,
        expanded
      }
    case COLLAPSE_ALL:
      return {
        ...state,
        expanded: []
      }
    case PATH_COUNTS_REQUEST:
      return {
        ...state,
        paths: { fetching: true, error: null }
      }
    case PATH_COUNTS_SUCCESS:
      return {
        ...state,
        paths: { fetching: false, data: payload }
      }
    case PATH_COUNTS_FAILURE:
      return {
        ...state,
        paths: { fetching: false, error: meta.error }
      }
    default:
      return state
  }
}

function getHierarchy (data, libraries) {
  return {
    ...data[''].COLLECTIONS,
    '<leaves>': libraries
      .map(library => library.library.library_token)
      .filter(library => /^virtual_/.test(library) === false)
  }
}

export function hierarchyRequest () {
  return {
    type: HIERARCHY_REQUEST
  }
}

export function hierarchySuccess (data, user) {
  return {
    type: HIERARCHY_SUCCESS,
    payload: data,
    meta: {
      libraries: user.libraries,
      superAdmin: isSuperAdmin(user)
    }
  }
}

export function hierarchyFailure (error) {
  return {
    type: HIERARCHY_FAILURE,
    meta: { error }
  }
}

export function toggleExpanded (path) {
  return {
    type: TOGGLE_EXPANDED,
    payload: path
  }
}

export function collapseAll () {
  return {
    type: COLLAPSE_ALL
  }
}

export function pathCountsRequest () {
  return {
    type: PATH_COUNTS_REQUEST
  }
}

export function pathCountsSuccess (data) {
  return {
    type: PATH_COUNTS_SUCCESS,
    payload: data
  }
}

export function pathCountsFailure (error) {
  return {
    type: PATH_COUNTS_FAILURE,
    meta: { error }
  }
}

export function fetchHierarchy () {
  return (dispatch, getState) => {
    const { auth } = getState()
    const options = {
      token: auth.token
    }
    dispatch(hierarchyRequest())
    fetch(ENDPOINT_HIERARCHY, options, dispatch).then(data => {
      dispatch(hierarchySuccess(data, auth.user))
    }, e => {
      dispatch(hierarchyFailure(e))
    })
  }
}

export function fetchAlbumPathCounts () {
  return (dispatch, getState) => {
    const { auth } = getState()
    const options = {
      token: auth.token
    }
    dispatch(pathCountsRequest())
    fetch(ENDPOINT_ALBUM_PATH_COUNTS, options, dispatch).then(data => {
      dispatch(pathCountsSuccess(data, auth.user))
    }, e => {
      dispatch(pathCountsFailure(e))
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/hierarchy.js